export interface MultiLangString {
  en: string;
  fr: string;
}
